import React from 'react'
import { useStateValue } from '../../state'
import Highlight from './Highlight'
import NotebookPagintaion from './NotebookPagination'

const HighlightsContainer = () => {
  let [currentState] = useStateValue()

  return (
    <div>
      <NotebookPagintaion />
      {currentState.highlights.length > 0 ? (
        currentState.highlights.map(hl => (
          <Highlight
            hId={hl.hId}
            sectionTitle={hl.sectionTitle}
            tags={hl.tags}
            cssClass={hl.cssClass}
            contentString={hl.contentString}
            note={hl.note}
            userIsOwner={hl.userIsOwner === 'true'}
            anchor={hl.anchor}
            key={hl.hId}
          />
        ))
      ) : (
        <p>
          {currentState.message
            ? currentState.message
            : 'No highlights in this chapter'}
        </p>
      )}
      <NotebookPagintaion />
    </div>
  )
}

export default HighlightsContainer
